module.exports = __webpack_public_path__ + "img/ceca6f2f983aeaa488062cd4a546366d.png";